import React, { memo, useCallback, useMemo } from 'react'

import {
  Icon,
  Button,
  Price as PriceIcon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import PriceContent from 'Pods/SearchPage/Shared/PriceContent/PriceContent'
import { clearPricing } from 'Pods/SearchPage/Store/actions/pricing'
import { DEFAULT_STATE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

const prefixIcon = <Icon notSpaced svgComponent={PriceIcon} color="dark" size="small" />

function Price() {
  const onSale = useSearchPageStore(state => state.onSale)
  const withSubscription = useSearchPageStore(state => state.withSubscription)
  const priceRanges = useSearchPageStore(state => state.priceRanges)
  const minPrice = useSearchPageStore(state => state.minPrice)
  const maxPrice = useSearchPageStore(state => state.maxPrice)

  const hasSelectedAnyFilter = useMemo(() => {
    return onSale
      || withSubscription
      || (priceRanges && priceRanges.length > 0)
      || (minPrice !== DEFAULT_STATE.minPrice && minPrice !== 0)
      || (maxPrice !== DEFAULT_STATE.maxPrice && maxPrice !== 0)
  }, [onSale, withSubscription, priceRanges, minPrice, maxPrice])

  const handleReset = useCallback(() => {
    clearPricing()
  }, [])

  const content = useMemo(() => (
    <>
      <PriceContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        Reset
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter])

  return (
    <FiltersWrapper
      placeholder="Price"
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Price)
